export const CONSTANTS = {
  DEFAULT_ROUTE: "defaultRoute",
  CUSTOM_ROLES: "customRoles",
};

const config = {
  namespace: "rvc",
};

export default config;
